// eslint-disable-next-line no-unused-vars
const errorHandler = (error: Error, info: { componentStack: string }) => {
  // TODO: Implement send error to email
};

export default errorHandler;
